import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const APP_NAME = "Crust POS";

// Window titles by route; the first matching pattern wins.
const TITLES: Array<[RegExp, string]> = [
  // Self-order kiosk
  [/^\/$/, "Kiosk Login"],
  [/^\/choice$/, "Order Type"],
  [/^\/sos\/confirmation\/[^/]+$/, "Order Confirmation"],
  [/^\/sos\/token-confirmation\/[^/]+$/, "Order Token"],
  [/^\/sos$/, "Self Order"],
  [/^\/pay$/, "Payment"],

  // Admin
  [/^\/admin\/login$/, "Admin Login"],
  [/^\/admin$/, "Dashboard"],
  [/^\/admin\/reports\/sales$/, "Sales Report"],
  [/^\/admin\/reports\/payments$/, "Payments Report"],
  [/^\/admin\/reports\/items$/, "Items Report"],
  [/^\/admin\/reports\/taxes$/, "Sales Taxes Report"],
  [/^\/admin\/reports/, "Reports"],
  [/^\/admin\/orders$/, "Orders"],
  [/^\/admin\/refunds$/, "Refunds"],
  [/^\/admin\/menu$/, "Menu Items"],
  [/^\/admin\/category$/, "Categories"],
  [/^\/admin\/addpreset$/, "Modifiers"],
  [/^\/admin\/deals$/, "Deals"],
  [/^\/admin\/managetax$/, "Tax"],
  [/^\/admin\/register$/, "Add Employee"],
  [/^\/admin\/manage$/, "Employees"],
  [/^\/admin\/roles$/, "Roles"],
  [/^\/admin\/location-admins$/, "Location Admins"],
  [/^\/admin\/loyalty$/, "User List"],
  [/^\/admin\/discount$/, "Loyalty"],
  [/^\/admin\/addhotelinformation$/, "Locations"],
  [/^\/admin\/platform-logo$/, "Platform Settings"],
  [/^\/admin\/developer-integrations$/, "Developer Integrations"],
  [/^\/admin\/promotional-email$/, "Promotional Email"],
  [/^\/admin\/reward-campaigns$/, "Reward Campaigns"],
  [/^\/admin\/ledger\/wallet-recharges$/, "Wallet Recharges"],
  [/^\/admin\/ledger\/admin-balance$/, "Admin Balance"],
  [/^\/admin\/ledger$/, "Ledger"],
  [/^\/admin/, "Admin"],

  // Sales POS
  [/^\/login$/, "Sales Login"],
  [/^\/sales$/, "Sales POS"],
  [/^\/sales\/all-orders$/, "All Orders"],

  // Kitchen
  [/^\/kitchen\/login$/, "Kitchen Login"],
  [/^\/kitchen$/, "Kitchen Orders"],
  [/^\/kitchen\/notification$/, "Kitchen Notifications"],
  [/^\/kitchen\/setting$/, "Kitchen Settings"],
  [/^\/kitchen\/support$/, "Kitchen Support"],
];

const PageTitle: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Routes are case-insensitive (e.g. /Sales), so match on lowercase.
    const path = pathname.replace(/\/+$/, "").toLowerCase() || "/";
    const match = TITLES.find(([pattern]) => pattern.test(path));
    document.title = match ? `${match[1]} | ${APP_NAME}` : APP_NAME;
  }, [pathname]);

  return null;
};

export default PageTitle;
